import { english } from '~domain/i18n/english';

const keys = {
  policies: {
    productName: {
      car: 'Car',
      home: {
        homeowner: 'Home | Homeowner',
        condo: 'Home | Condo',
        tenant: 'Home | Tenant',
      },
    },
    policyCard: {
      effectiveDate: 'Effective date',
      expiryDate: 'Expiry date',
      policyNumber: 'Policy number',
      insurer: 'Insurance company',
      buttonModifyPolicy: 'Modify Policy',
      buttonDocuments: 'Documents',
      tag: {
        cancelled: 'Cancelled',
        expired: 'Expired',
        renewal: 'Renewal',
      },
    },
    attachment: {
      filename: 'YouSet Policy {{0}}.{{1}}',
    },
    modification: {
      options: {
        address: {
          subtitle: 'Change your residential address in your policy.',
          title: 'Address',
        },
        addReplaceRemoveCar: {
          subtitle: 'Add, replace or remove a car.',
          title: 'Cars',
        },
        bankingInformation: {
          subtitle: 'Change bank account for monthly pre-authorized debit payments.',
          title: 'Banking information',
        },
        cancellation: {
          subtitle: 'Cancel your policy or notify us that you won’t renew it for next year.',
          title: 'Cancellation and non-renewal',
        },
        claims: {
          subtitle: 'Make a claim.',
          title: 'Claims',
        },
        coInsured: {
          subtitle: 'Add or remove a co-insured to your home policy.',
          title: 'Co-insured',
        },
        contactInformation: {
          subtitle: 'Update your phone number and email.',
          title: 'Contact information',
        },
        help: {
          subtitle: 'Write us a message if the change you need to make is not among the options.',
          title: 'Need help?',
        },
        occasionalDrivers: {
          subtitle: 'Add or remove an occasional driver to your car policy.',
          title: 'Occasional driver',
        },
        requestPolicyCopy: {
          subtitle: 'Request a copy of your insurance policy.',
          title: 'Policy Information',
        },
      },
    },
    documents: {
      downloadButton: 'Download',
      empty: 'No documents available at the moment.',
      privateLabel: 'This document is private, therefore, it is not visible in the user portal',
      notifyUserLabel: 'The user was or will be notified by email',
      notifyBrokerLabel: 'A Close task was or will be created',
      ...english.policies.attachments,
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
